import { useState } from "react";
import { Globe } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { getLang, setLang, t } from "@/i18n";

export const LANG_OPTIONS: [string, string][] = [["en", "EN"], ["es", "ES"], ["zh", "中文"], ["fr", "FR"]];

export const LangSelect = ({ value, onChange, testid }: { value: string; onChange: (v: string) => void; testid: string }) => (
  <label className="h-8 sm:h-10 rounded-full flex items-center gap-1 pl-1.5 sm:pl-2.5 pr-1 faint hover:text-[var(--text-primary)] hover:bg-[var(--bg-surface-hover)] transition-colors cursor-pointer" title={t("Language")}>
    <Globe size={17} className="hidden sm:block" />
    <select className="bg-transparent outline-none text-xs font-semibold uppercase cursor-pointer" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {LANG_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </label>
);

export function LanguageMenu() {
  const api = useApi();
  const [lang, setL] = useState(getLang());
  const change = async (next: string) => {
    try {
      await api.put("/me/language", { language: next });
      setL(next);
      setLang(next);
      window.location.reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return <LangSelect value={lang} onChange={change} testid="language-select" />;
}

export const SiteLanguageMenu = () => (
  <LangSelect value={getLang()} onChange={(v) => { setLang(v); window.location.reload(); }} testid="site-language-select" />
);
